/**
 * CampCreateReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * CampCreateReq
 */
export interface CampCreateReq {
  /** 营地名称 */
  name: string
  /** 营地简介 */
  bio?: string
  /** 创建用户ID（为空则使用官方账号） */
  create_user_id?: string
  /** 头像文件ID */
  avatar_id?: string
}

/**
 * CampCreateReq Schema
 */
export const CampCreateReqSchema: SchemaDefinition = {
  properties: {
    name: {
      description: '营地名称',
      format: 'string',
      maxLength: 50,
      minLength: 1,
      type: 'string',
      label: '营地名称',
    },
    bio: {
      description: '营地简介',
      format: 'string',
      maxLength: 500,
      type: 'string',
      label: '营地简介',
    },
    create_user_id: {
      description: '创建用户ID（为空则使用官方账号）',
      format: 'string',
      type: 'string',
      label: '创建用户ID',
    },
    avatar_id: {
      description: '头像文件ID',
      format: 'string',
      type: 'string',
      label: '头像文件ID',
    },
  },
  required: ['name'],
  type: 'object',
}
